import React, {useState} from "react";
import {useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import moment from "moment";

import Loading from "@/components/Loading";
import Page from "@/components/Page";
import MainActions from "@/components/MainActions";
import Breadcrumbs from "@/components/Breadcrumbs";
import VLFCard from "@/components/Card";
import VLFSelectNew from "@/components/Input/SelectNew";
import VLFDatePicker from "@/components/Input/DatePicker";

import {PlayerAPI} from "@/api/player";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SaveIcon from "@mui/icons-material/Save";

import {
	ERROR_OPERATION,
	SUCCESSFUL_OPERATION,
	vasOptions,
} from "@/utils/constants";
import {checkRequiredFields} from "@/utils/functions";

function HandleVASPage(props) {
	const {handleNotification} = props;

	const {id} = useParams();
	const navigate = useNavigate();
	const playerId = useSelector((state) => state.user?.playerId);

	const [loading, setLoading] = useState(false);
	const [fields, setFields] = useState({});

	const getRequiredFields = () => {
		return ["vasDate", "vasValue"];
	};

	const saveVAS = async () => {
		setLoading(true);
		try {
			await PlayerAPI.createVAS({
				id,
				playerId,
				vasDate: moment(fields.vasDate).format("YYYY-MM-DD"),
				vasValue: fields.vasValue?.value,
			});
			navigate("/measurations/vas");
			handleNotification(SUCCESSFUL_OPERATION, "success");
		} catch (error) {
			handleNotification(ERROR_OPERATION, "error");
		} finally {
			setLoading(false);
		}
	};

	const mainActions = [
		{
			icon: <ArrowBackIcon />,
			title: "Indietro",
			onClick: () => navigate("/measurations/vas"),
			color: "info",
		},
		{
			icon: <SaveIcon />,
			title: "Salva",
			onClick: saveVAS,
			disabled: checkRequiredFields(getRequiredFields(), fields).length
				? true
				: false,
		},
	];

	const breadcrumbsElements = [{label: "VAS", path: "/measurations/vas"}];

	return (
		<Page className="page-container">
			<Loading visible={loading} />
			<Breadcrumbs
				elements={breadcrumbsElements}
				actions={<MainActions actions={mainActions} />}
			/>
			<div className="row no-margin">
				<div className="col-sm-12 padding-small">
					<VLFCard
						title="Informazioni principali"
						content={
							<div className="row">
								<div className="col-sm-12 col-md-6">
									<VLFDatePicker
										label="Data"
										value={fields.vasDate}
										onChange={(value) => {
											setFields({...fields, vasDate: value});
										}}
										required
										size="small"
									/>
								</div>
								<div className="col-sm-12 col-md-6">
									<VLFSelectNew
										options={vasOptions}
										value={fields.vasValue}
										onChange={(value) => {
											setFields({...fields, vasValue: value});
										}}
										required
										label="VAS"
										sorted={false}
									/>
								</div>
							</div>
						}
					/>
				</div>
			</div>
		</Page>
	);
}

export default HandleVASPage;
